import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { FeaturedInfoCard } from "@/components/adg4/featured-info-card/src/featured-info-card";
import { wacToken } from "@/libraries/design/foundations";

const StarEyelash = () => (
    <svg
        width="91"
        height="128"
        viewBox="0 0 91 128"
        fill="none"
        css={eyebrowDecorationStyles}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.1919 97.4633C18.5051 100.888 22.4421 109.105 15.928 107.971C18.398 108.893 3.35852 104.721 5.4315 107.828C5.12894 108.057 7.5196 109.101 7.60519 108.784C10.1769 108.496 15.4069 111.082 19.4648 111.452C19.3262 111.466 18.3325 132.757 21.219 123.284C21.4893 121.522 20.5317 107.969 28.1761 113.007C46.5746 112.338 33.6467 108.907 22.5678 108.713C23.0526 106.725 23.2983 92.2752 20.1917 97.4696L20.1919 97.4633Z"
            fill="#101214"
        />
        <path
            d="M45.1941 2.54737C44.118 7.29219 46.724 13.1543 41.9964 14.2707C41.2427 12.7139 27.2202 13.2356 34.636 15.4278C34.8038 15.094 34.6866 14.6381 35.0066 14.8431C35.0312 16.8097 37.6739 14.7092 38.1163 15.5964C37.456 16.7936 40.9115 14.8072 40.0188 16.0032C41.2368 16.7961 42.8844 16.9245 44.6248 16.9052C45.187 16.2199 42.7961 35.4556 46.6703 27.2963C44.8131 26.6524 47.8968 27.2416 46.1719 24.4415C47.3339 21.9039 47.8155 20.2111 47.9113 16.8478C51.7885 18.3419 67.8446 15.1285 56.1251 13.9596C53.7596 13.3055 45.1645 15.7482 48.5975 9.77921C47.0037 8.37126 48.3714 -2.1109 45.1874 2.55973L45.1941 2.54737Z"
            fill="#101214"
        />
        <path
            d="M15.0597 40.5725C13.9836 45.3174 16.5895 51.1794 11.862 52.2957C11.1083 50.739 -2.9141 51.2607 4.50168 53.4529C4.66944 53.1191 4.5522 52.6632 4.87218 52.8682C4.89675 54.8348 7.53944 52.7342 7.9819 53.6215C7.32155 54.8186 10.7771 52.8323 9.88439 54.0282C11.1024 54.8212 12.75 54.9496 14.4904 54.9303C15.0526 54.245 12.6615 73.4869 16.5359 65.3214C14.6787 64.6775 17.7624 65.2667 16.0375 62.4666C17.1995 59.929 17.6811 58.2362 17.7769 54.8729C21.5108 56.1363 37.3939 53.6145 26.0486 51.7479C24.1628 51.8002 14.9129 53.512 18.4633 47.798C16.8695 46.3901 18.2372 35.908 15.0533 40.5786L15.0597 40.5725Z"
            fill="#101214"
        />
        <path
            d="M73.2886 54.155C72.2125 58.8998 74.8185 64.7619 70.0909 65.8783C69.3372 64.3215 55.3148 64.8432 62.7305 67.0354C62.8983 66.7016 62.7811 66.2457 63.1011 66.4507C63.1257 68.4173 65.7684 66.3168 66.2108 67.204C65.5505 68.4012 69.006 66.4148 68.1133 67.6108C69.3313 68.4037 70.979 68.5321 72.7193 68.5128C73.2815 67.8275 70.8904 87.0694 74.7648 78.9039C72.9077 78.26 75.9913 78.8492 74.2664 76.0491C75.4284 73.5115 75.9101 71.8187 76.0059 68.4554C79.8831 69.9495 95.9391 66.7362 84.2196 65.5672C81.8541 64.9132 73.259 67.3558 76.6921 61.3868C75.0982 59.9789 76.4659 49.4967 73.2819 54.1673L73.2886 54.155Z"
            fill="#101214"
        />
    </svg>
);

export const PlanSection = () => {
    const intl = useIntl();

    return (
        <section css={sectionStyles}>
            <div css={containerStyles}>
                <header css={headerStyles}>
                    <div css={eyebrowStyles}>
                        <StarEyelash />
                        <h4 css={containerHeaderStyle}>
                            <FormattedMessage
                                id="HomePageBpsRedesignTemplate.confluenceHero.planSectionHeader"
                                defaultMessage="Top Confluence features to use with Jira"
                            />
                        </h4>
                    </div>
                </header>
            </div>
            <div css={featuresGridStyles}>
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/250cks0k17pi34l6x1j31800hsxcehd6.webp",
                            alt: ""
                        }
                    }}
                    title={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.ListView.Header",
                        defaultMessage: "Customizable templates"
                    })}
                    body={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.ListView.Description",
                        defaultMessage:
                            "Templates for blogs, release notes, product requirements, and more."
                    })}
                />
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/38jekvk14t7333848nu2al88021713cg.webp",
                            alt: ""
                        }
                    }}
                    title={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.Calendar.Header",
                        defaultMessage: "Whiteboards"
                    })}
                    body={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.Calendar.Description",
                        defaultMessage:
                            "Plan, edit, and organize. Turn sticky notes into issues in one click. "
                    })}
                />
                <FeaturedInfoCard
                    image={{
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0y02s106s51xr6000xqob32f7e4a21iw.webp",
                            alt: ""
                        }
                    }}
                    title={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.SprintsBacklog.Header",
                        defaultMessage: "Project documentation hub"
                    })}
                    body={intl.formatMessage({
                        id: "HomePageBpsRedesignTemplate.HighlightPlanSection.Card.SprintsBacklog.Description",
                        defaultMessage:
                            "Create documents and project updates in one place that syncs in real-time."
                    })}
                />
                <div css={backgroundStyles} />
            </div>
        </section>
    );
};

const containerStyles = css({
    "position": "relative",
    "maxWidth": "1301px",
    "margin": "0 auto",
    "overflowX": "clip",
    "overflowClipMargin": "border-box",
    "zIndex": 0,

    "&::before": {
        content: "",
        position: "absolute",
        pointerEvents: "none",
        width: "1301px",
        height: "max(339px, calc(100% + 65px))",
        zIndex: -1,
        inset: "0 0 0 50%",
        transform: "translateX(-50%)",

        [media.below.lg]: {
            inset: "0 0 0 auto",
            transform: "none"
        },

        [media.below.sm]: {
            inset: "0 -10% 0 auto"
        },

        [media.below.xs]: {
            inset: "0 -20% 0 auto"
        }
    }
});

const containerHeaderStyle = css({
    marginBlockEnd: 0,
    [media.below.sm]: {
        fontSize: "24px !important"
    }
});

const headerStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "gap": "8px",
    "marginBlockStart": "-75px",
    "margin": "0 auto 32px auto",
    "maxWidth": "min(1168px, calc(100% - 120px))",

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".body-md": {
        margin: "0",
        maxWidth: "768px"
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".eyebrow-md": {
        margin: "0"
    },

    [media.below.sm]: {
        maxWidth: "calc(100% - 64px)",
        padding: "55px 0 0 0"
    }
});

const eyebrowStyles = css({
    order: -1,
    display: "flex",
    flexDirection: "column",
    gap: "14px"
});

const eyebrowDecorationStyles = css({
    translate: "-60px 60px",
    [media.below.sm]: {
        display: "none"
    }
});

const featuresGridStyles = css({
    "display": "grid",
    "position": "relative",
    "gridTemplateColumns": "1fr",
    "gap": "32px",
    "margin": "0 32px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".body": {
        borderRadius: "0 0 .5rem .5rem",
        width: "100%",
        border: `1px ${wacToken(`color.neutral.light400`)}`,
        borderStyle: "none solid solid solid"
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "img": {
        width: "100%",
        height: "auto",
        borderRadius: ".5rem .5rem 0 0",
        border: `1px ${wacToken(`color.neutral.light400`)}`,
        borderStyle: "solid solid none solid "
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h3": {
        fontSize: "20px !important"
    },

    [media.above.sm]: {
        maxWidth: "min(1168px, calc(100% - 120px))",
        margin: "0 auto",
        gridTemplateColumns: "repeat(3, 1fr)"
    }
});

const backgroundStyles = css({
    position: "absolute",
    insetInlineStart: "-60px",
    insetBlockStart: "48%",
    width: "min(calc(100% + 120px), 100vw)",
    height: "75%",
    backgroundColor: wacToken("color.primary.blue"),
    overflow: "hidden",
    zIndex: "-1",
    clipPath:
        "polygon(0% 0, 50% 0, 50% 10%, 98.5% 0%, 100% 85%, 17.75% 100%, 17.25% 85%, 0 85%)",

    [media.below.sm]: {
        insetInlineStart: "-32px",
        insetBlockStart: "5%",
        width: "min(calc(100% + 64px), 100vw)",
        height: "100%",
        clipPath:
            "polygon(0% 0,165% 22%,100% 98%,24.25% 99.5%,24% 97.5%,0% 97.5%)"
    }
});

const sectionStyles = css({
    marginBlockStart: "40px",
    [media.above.md]: {
        marginBlockStart: "70px"
    }
});
